import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import bluetooth from "../../../assets/icons/bluetooth.svg";
import buttonClose from "../../../assets/icons/buttonClose.svg";
import dinamo from "../../../assets/icons/Dinamo.svg";
import lightConnect from "../../../assets/icons/lightConnect.svg";
import lightConnectBlue from "../../../assets/icons/lightConnectBlue.svg";
import localization from "../../../assets/icons/localiozation.svg";
import { TextsProps } from "../../../database/txt.interface";
import { AppActions } from "../../../store/ducks/app";
import { Container } from "./styles";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

const ModalConectaHandGripPassos: React.FC = () => {
	const dispatch = useDispatch();

	const classes = useStyles();
	const is_open_conecta_hand_grip_passos = useSelector(
		(state: any) => state.app.is_open_conecta_hand_grip_passos
	);
	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
	const ModalBluetoothClose = () => {
		dispatch(AppActions.set_modal_conecta_hand_grip_passos(false));
	};
	useEffect(()=>{
		dispatch(AppActions.set_modal_conecta_hand_grip(false));
	},[])

	return (
		<div>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={is_open_conecta_hand_grip_passos}
				onClose={ModalBluetoothClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={is_open_conecta_hand_grip_passos}>
					<Container>
						<img
							className="close"
							src={buttonClose}
							onClick={ModalBluetoothClose}
							alt="Close"
						/>
						<div className="divText">
							<p className="text">{current_language?.modal_conecta_hand_grip_passos}</p>
						</div>

						<div className="group">
							<div className="item">
								<img src={bluetooth} alt="bluetooth" />
								<p className="textSecundary">Bluetooth</p>
							</div>

							<div className="item">
								<img src={localization} alt="localização" />
								<p className="textSecundary">{current_language?.localizacao}</p>
							</div>
						</div>

						<div className="group">
							<div className="item">
								<img src={lightConnect} alt="Luz verde" />
								<p className="textSecundary">
									{current_language?.luz_piscando_verde}
								</p>
							</div>

							<div className="item">
								<img src={lightConnectBlue} alt="Luz azul" />
								<p className="textSecundary">
									{current_language?.luz_piscando_azul}
								</p>
							</div>
						</div>
					</Container>
				</Fade>
			</Modal>
		</div>
	);
};

export default ModalConectaHandGripPassos;
